"use no memo";

/* eslint-disable complexity */
import { isYelpPlatform } from '@local/utils';

import { getYelpData } from 'helpers/yelp';

import { UserDataType } from 'types/customer';

import buildOrderPayload, {
  BuildOrderPayloadOrderType,
} from './buildOrderPayload';

export default function buildValidatePayload(
  order: BuildOrderPayloadOrderType,
  user: UserDataType,
  fulfillmentEta?: { pickup?: string; delivery?: string }
) {
  // Only validate estimated_fulfillment_time we received from restaurant endpoint against validate
  // endpoint on initiateCheckout action by adding estimated_fulfillment_time to order payload
  let orderPayload = buildOrderPayload(order, user);

  const pickupPrepTime = fulfillmentEta?.pickup;

  if (pickupPrepTime) {
    orderPayload = {
      ...orderPayload,
      estimated_fulfillment_time: order.estimated_fulfillment_time
        ? order.estimated_fulfillment_time
        : pickupPrepTime,
    };
  }

  // If running the Yelp theme, retrieve opportunity token from session storage.
  // Modify endpoint + version and include the token in the HTTP request to Hermosa.
  if (isYelpPlatform()) {
    orderPayload.opportunity_token = getYelpData().opportunity_token;
  }

  return orderPayload;
}
